import React from 'react';
import Button from 'widgets/Button';

import ShoppingListsButton from 'apps/shoppingLists/containers/ShoppingListsButton';
import Icon from '../../../../widgets/Icon/Icon';

export default class BopShoppingListButton extends ShoppingListsButton {
  render() {
    return (
      <Button
        className="bop-addShoppingListButton gn-button"
        type="button"
        onClick={this.open}
        tertiary
      >
        <Icon name="add-to-shopping-list" />
        <span className="bop-addShoppingListButton__label">Add to list</span>
      </Button>
    );
  }
}
